import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller } from 'react-hook-form';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import TableComponent from './Filtrado';

const BuscadorComponen = props => {
  // const { Terminales } = props
  const [data, setData] = useState();
  const [verTabla, setVerTabla] = useState(0);
  const [loading, setLoading] = useState(true);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const invoice = data.invoice;
      const result = await axios.get(`https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev/outsource/juridica/${invoice}`);
      const datos = result.data;
      const body = datos.body;
      setLoading(false);
      if (datos.status) {
        setVerTabla(1);
        setData(body.data);
      } else {
        setData([]);
        toast.error(body.message);
      }
      // Reset the form and clear the invoice field
      reset({
        invoice: '', // Ensure invoice field is cleared
      });
    } catch (error) {
      toast.error('Algo salió mal..');
      setLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 800);
  }, []);

  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h1 className="formulario">Buscar factura Jurídicas</h1>
        <hr style={{ borderTop: "1px solid #dcdcdc", margin: "20px 0" }} />
        <Row className="contenedorF-Filtrado mbottom-20">
          <Col xs={12} sm={6} md={6} lg={6} xl={6}>
            <Form.Group className="inputmayuscula">
              <Form.Label className="texto-label">Número de Factura SAP</Form.Label>
              <Controller
                name="invoice"
                control={control}
                rules={{ required: "El campo es obligatorio" }}
                render={({ field: { onChange, onBlur, value } }) => (
                  <Form.Control
                    type="number"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.value)}
                    value={value}
                    style={{ textAlign: "center" }}
                  />
                )}
              />
              {errors.invoice && (
                <Form.Text id="passwordHelpBlock" className="error">
                  El campo es obligatorio
                </Form.Text>
              )}
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={6} lg={6} xl={6}>
            <Button
              type="submit"
              variant="primary"
              className="btn btn-primary mtop-20 boton"
              style={{ width: "100%", marginTop: "32px" }}
            >
              Buscar
            </Button>
          </Col>
        </Row>
        <hr style={{ borderTop: "1px solid #dcdcdc", margin: "20px 0" }} />
      </form>
      {verTabla === 1 ? (
        <TableComponent data={data} />
      ) : null}
    </>
  );
};

export default BuscadorComponen;
